@if (description) {
  <div class="row mb-4">
    <div class="col-lg-12 text-justify">{{ description | translate }}</div>
  </div>
}
@for (document of documents; track document; let i = $index) {
  <div class="row document-row">
    <div
      class="col-lg-8 col-md-8"
      [class.col-lg-6]="document.attachmentType?.sampleUrl"
      [class.col-md-6]="document.attachmentType?.sampleUrl"
    >
      <div class="d-flex">
        <div class="document-index">{{ i + 1 }}.</div>
        <div class="document-title">
          {{ document.attachmentType.name }}
          @if (!document.attachmentType.isOptional) {
            <span class="tw-text-primary">*</span>
          }
          @if (document.attachmentType?.sampleUrl || document.attachmentType?.subTitle) {
            <div class="tw-text-xs tw-font-normal">
              {{ document.attachmentType.subTitle }}
              @if (document.attachmentType?.sampleUrl) {
                <a
                  href="{{ document.attachmentType.sampleUrl }}"
                  class="p-link-primary p-link-underline"
                  target="_blank"
                >
                  {{ document.attachmentType.sampleUrlText }}
                </a>
              }
            </div>
          }
        </div>
      </div>
    </div>
    @if (document.attachmentType?.sampleUrl && document.attachmentType?.sampleDesc === null) {
      <div class="col-lg-2 col-md-3 text-right align-self-center">
        <span
          class="cursor-pointer text-primary view-sample"
          (click)="viewSample(document.attachmentType.sampleUrl)"
        >
          {{ 'signUp.downloadTemplate' | translate }}
        </span>
      </div>
    }
    @if (!document.attachmentType?.canHaveMultiple) {
      <div class="col-lg-4 col-md-4">
        @if (!document.isUploading) {
          <div class="input-field">
            @if (!document.url) {
              <div
                class="document-upload cursor-pointer"
                agmoUploader
                [accept]="accept"
                (selectFiles)="selectFile($event, document)"
              >
                <div class="document-text">{{ 'signUp.uploadDocument' | translate }}</div>
                <div class="pitchin-icon pitchin-icon-upload"></div>
              </div>
            }
            @if (document.url) {
              <div class="document-upload uploaded">
                <div class="document-text" (click)="viewSample(document.url)">
                  {{ document.fileName }}
                </div>
                @if (document.attachmentType?.isOptional || !isHideDelete) {
                  <div
                    class="pitchin-icon pitchin-icon-delete"
                    (click)="removeDocument(document, i)"
                  ></div>
                }
              </div>
            }
          </div>
        }
        @if (document.isUploading) {
          <agmo-loading></agmo-loading>
        }
      </div>
    }
    @if (document.attachmentType?.canHaveMultiple) {
      <div class="col-lg-4 col-md-4">
        <div class="document-upload cursor-pointer" (click)="uploadAdditionalDocument(document)">
          <div class="document-text">
            {{ 'company.uploadAdditionalDocuments' | translate }}
          </div>
          <div class="pitchin-icon pitchin-icon-upload"></div>
        </div>
      </div>
    }
  </div>
  @if (document.subAttachments && document.subAttachments.length > 0) {
    @for (subAttachment of document.subAttachments; track subAttachment; let x = $index) {
      <div class="row document-row sub-document-row">
        <div class="col-lg-8 col-md-8 d-flex">
          <div class="document-index">{{ i + 1 }}.{{ x + 1 }}.</div>
          <div class="document-title">
            {{ subAttachment.attachmentName || '-' }}
          </div>
        </div>
        <div class="col-lg-4 col-md-4">
          <div class="input-field">
            @if (subAttachment.url) {
              <div class="document-upload uploaded">
                <div class="document-text" (click)="viewSample(subAttachment.url)">
                  {{ subAttachment.fileName }}
                </div>
                <div
                  class="pitchin-icon pitchin-icon-delete"
                  (click)="removeDocument(subAttachment, i)"
                ></div>
              </div>
            }
          </div>
          @if (subAttachment.isUploading) {
            <agmo-loading></agmo-loading>
          }
        </div>
      </div>
    }
  }
}
